import { connect } from 'react-redux'
import { deleteProcurement, fetchProcurements } from '../actions'
import DeleteDialog from '../components/DeleteDialog'

const mapStateToProps = (state) => {
	return {
		dialogTitle: 'Delete Procurement'
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		onDeleteClick: (id) => { 
			dispatch(deleteProcurement({id: id})).then(() => {
				dispatch(fetchProcurements())
			})
		}
 	}
}

const DeleteDialogContainer = connect(
	mapStateToProps, mapDispatchToProps
)(DeleteDialog)

export default DeleteDialogContainer


// WEBPACK FOOTER //
// ./src/containers/DeleteProcurementDialogContainer.js